import { makeAutoObservable } from 'mobx';
import DetailsType from '../interfaces/DetailsType';

export default class DetailsStore {
    type: DetailsType | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    setType(value: DetailsType) {
        this.type = value;
    }

    close() {
        this.type = null;
    }

    clear() {
        this.close();
    }
}